import { DropdownEditor, DropdownListItemProps } from '@approvalmax/ui';
import { domain } from 'modules/data';
import { FC, memo } from 'react';

import { messages } from './PaymentDetailsListItem.messages';

export const PaymentDetailsListItem: FC<DropdownListItemProps<domain.PaymentDetails>> = memo((props) => {
    return (
        <DropdownEditor.ListItem {...props}>
            {(text, item: domain.PaymentDetails) => {
                const countryName = item.bankAccount.country === 'GB' ? messages.ukCountry : item.bankAccount.country;

                return (
                    <div>
                        <b>{text}</b>

                        <div>
                            <span>{countryName}</span>

                            <span> &middot; </span>

                            <span>{item.bankAccount.currency}</span>

                            <span> &middot; </span>

                            <span>{item.bankAccount.accountNumber}</span>
                        </div>
                    </div>
                );
            }}
        </DropdownEditor.ListItem>
    );
});

PaymentDetailsListItem.displayName = 'PaymentDetailsListItem';
